// Yugiq Insights — SEO-focused long-tail articles (static)

export const INSIGHTS = [
  {
    slug: "ai-voice-agents-real-estate-india",
    title: "How AI Voice Agents Cut Missed Calls for Indian Real Estate",
    excerpt:
      "Property leads worth crores go cold in minutes. Here's how an AI voice agent answers, qualifies and books site visits in Hindi, Marathi and English — 24/7.",
    category: "AI Agents",
    readTime: "6 min read",
    date: "2026-01-12",
    keywords: "AI voice agent real estate, real estate lead automation India, AI calling agent Hindi Marathi",
    body: [
      { h: "The 5-minute window", p: "Studies consistently show buyers convert with whoever responds first. In real estate — where a single lead can be worth ₹2–5 crore — a 2-hour callback delay is lost revenue. Human teams simply can't answer every call at 11pm or during a site visit." },
      { h: "What an AI voice agent actually does", p: "A Yugiq AI voice human picks up instantly, speaks the caller's language (Hindi, Marathi or English), answers project questions, shares brochures and floor plans over WhatsApp, and books a site visit straight into your calendar — then follows up if the lead goes quiet." },
      { h: "Real numbers", p: "Developers using AI voice + WhatsApp follow-up typically see 21× faster first response, ~2.8× more site visits booked, and up to 40% lower cost-per-lead because no enquiry is dropped." },
      { h: "Getting started", p: "Start with one project and one language. Point your missed-call and WhatsApp enquiries to the agent, watch the CRM fill up, then expand. Most builders are live within a week." },
    ],
  },
  {
    slug: "website-vs-app-what-to-build-first-2026",
    title: "Website vs App: What Should Your Business Build First in 2026?",
    excerpt:
      "A practical, no-hype framework to decide between a website, a mobile app, or a PWA — based on your customers, budget and goals.",
    category: "Product",
    readTime: "5 min read",
    date: "2026-01-06",
    keywords: "website vs app, should I build an app or website, mobile app development India 2026",
    body: [
      { h: "Start with the job to be done", p: "A website is for discovery and conversion — it's where people find you, trust you and take an action. An app is for repeat engagement — it earns a home-screen icon only when customers come back often (loyalty, tracking, bookings)." },
      { h: "The default answer for most SMBs", p: "Ship a fast, SEO-first website first. It's cheaper, indexable by Google, and works on every device instantly. 90% of early-stage businesses do not need a native app on day one." },
      { h: "When an app makes sense", p: "Build an app when you have proven repeat usage, need push notifications, offline access, device features (camera, GPS) or a loyalty loop. A PWA can bridge the gap at a fraction of the cost." },
      { h: "The Yugiq approach", p: "We usually launch a conversion-tuned website, layer in AI automation, and add an app once the data proves demand — so you spend on what actually moves revenue." },
    ],
  },
  {
    slug: "business-workflows-to-automate-with-ai",
    title: "5 Business Workflows You Can Automate with AI Today",
    excerpt:
      "You don't need a data-science team. These five everyday workflows are the fastest wins when you bring AI into your operations.",
    category: "Automation",
    readTime: "4 min read",
    date: "2025-12-28",
    keywords: "business automation AI, AI workflow automation, automate business processes India",
    body: [
      { h: "1. Lead response", p: "Instant replies to every enquiry across WhatsApp, web chat and calls — qualified and pushed into your CRM before a human touches it." },
      { h: "2. Appointment booking & reminders", p: "AI books, confirms and reminds — cutting no-shows by up to 35% without your front desk lifting a finger." },
      { h: "3. Review collection", p: "Automatically nudge happy customers for Google reviews at the right moment, then auto-reply to every review to protect your reputation." },
      { h: "4. Content & social", p: "Generate on-brand posts, captions and SEO pages weekly, scheduled across channels." },
      { h: "5. Reporting", p: "A live dashboard that turns scattered data into plain-English insights and next actions — no spreadsheets." },
    ],
  },
  {
    slug: "multilingual-ai-chatbots-hindi-marathi",
    title: "Multilingual AI Chatbots: Reaching Customers in Hindi & Marathi",
    excerpt:
      "English-only chat leaves money on the table in India. Here's why language-matching AI wins more trust — and more sales.",
    category: "AI Agents",
    readTime: "5 min read",
    date: "2025-12-20",
    keywords: "multilingual chatbot Hindi Marathi, regional language AI chatbot India, vernacular AI support",
    body: [
      { h: "Language is trust", p: "Customers explain their real needs more openly in their mother tongue. A chatbot that replies in Hindi or Marathi feels human — and humans buy from people they trust." },
      { h: "Not translation — understanding", p: "A good multilingual AI human detects the language, keeps context across a mixed Hinglish conversation, and responds naturally — including sharing brochures, prices and reviews inline." },
      { h: "Where it moves the needle", p: "Real estate, healthcare, automobile and education see the biggest lift, because high-value decisions are emotional and local." },
      { h: "One agent, three languages", p: "Yugiq's AI human handles English, Hindi and Marathi from a single setup — so you reach every customer without hiring three teams." },
    ],
  },
  {
    slug: "local-seo-ai-first-playbook",
    title: "SEO for Local Service Businesses: An AI-First Playbook",
    excerpt:
      "How clinics, gyms, restaurants and dealerships can rank on page one — using AI to produce content and win reviews on autopilot.",
    category: "SEO",
    readTime: "7 min read",
    date: "2025-12-14",
    keywords: "local SEO India, AI content SEO, rank on Google page 1 local business",
    body: [
      { h: "Win the map pack first", p: "For local businesses, the Google Map pack drives most calls. Nail your Google Business Profile, categories, photos and — crucially — a steady stream of fresh reviews." },
      { h: "Publish helpful content, weekly", p: "Answer the exact questions customers search: 'best wellness clinic in Pune', 'car service near me'. AI can draft SEO-ready pages weekly; you approve and publish." },
      { h: "Reviews are ranking fuel", p: "Automated review requests + fast, on-brand replies signal trust to both customers and Google. This alone often moves you up the local pack." },
      { h: "Measure what matters", p: "Track calls, direction requests and form fills — not vanity traffic. AI-first SEO ties content to actual revenue." },
    ],
  },
  {
    slug: "cost-to-build-website-in-india",
    title: "How Much Does It Cost to Build a Website in India?",
    excerpt:
      "A transparent breakdown of what a professional website really costs in 2026 — and where AI cuts both time and budget.",
    category: "Product",
    readTime: "6 min read",
    date: "2025-12-05",
    keywords: "website cost India, how much website costs 2026, website development pricing India",
    body: [
      { h: "It depends on the job", p: "A landing page, a 6-page business site, an e-commerce store and a booking platform are wildly different projects. Pricing should follow scope and outcomes — not a fixed template." },
      { h: "What you're actually paying for", p: "Design, development, copy, SEO setup, integrations (payments, WhatsApp, CRM) and — the part most skip — conversion optimisation. Cheap sites that don't convert are the most expensive." },
      { h: "Where AI cuts cost", p: "AI accelerates content, imagery and code, so a site that took 6 weeks can ship in days — passing the savings to you without cutting quality." },
      { h: "Our recommendation", p: "Get a fixed, itemised quote tied to goals. Yugiq gives a custom-priced roadmap after a free audit — you only pay for what moves the needle." },
    ],
  },
];

export const getInsight = (slug) => INSIGHTS.find((i) => i.slug === slug);
